import { Currency } from '@/types';

export const SET_CURRENCIES = 'SET_CURRENCIES';

export interface StateCurrency {
    currencies: Currency[];
}
